import axios from 'axios';

const getFamily = (id) => {
    return axios.get(`/merchant/${id}/family`);
}

export default {
    getFamily
}